/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatExitMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_EXIT);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler'] = com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ChatExitMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler.prototype.processMessage = function(message) {
	// AsyncChat logic for surveys.
	var conversationResolved = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CONVERSATION_RESOLVED) === "true";
	var evtData = {
		conversationResolved: conversationResolved
	};
	com.inq.flash.client.control.FlashPeer.setEventDataForSurvey(evtData);
	var forcedClose = message.getPropertyAsBoolean(com.inq.flash.client.data.MessageFields.KEY_FORCED_CLOSE);
	if (conversationResolved) {
		if (!forcedClose) {
			com.inq.flash.client.control.FlashPeer.fireConversationResolvedEvent();
		}
		com.inq.flash.client.control.FlashPeer.resetConversationManager();
	}
	var didClientDisconnect = false;
	//This applies when chat is supported in multiple windows/tabs (e.g embedded chats) and user closes the chat in one window
	if (com.inq.flash.client.data.MessageFields.TYPE_CHAT_EXIT === message.getMessageType()
		&& "client" === message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USER_TYPE)) {
		didClientDisconnect = true;
	} else {
		com.inq.flash.client.control.FlashPeer.setAgentClosedChat(true);
	}
	var tYLabel = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_TY_LABEL);
	if (tYLabel != null && tYLabel != "undefined" && tYLabel != "null") {
		com.inq.flash.client.chatskins.SkinControl.tYImageLabel = tYLabel;
		// tYLabel contains a status message for the customer.
		// This message is being added to `agentExitLine` when auto-transfer failed (no agents available) and `Thank-you image` is disabled (in Portal).
		// Ref. to ChatExitMessageHandler.java in CR, the case where `auto_transfer_ignored_chatroom` is true.
		com.inq.flash.client.control.FlashVars.setValue("agentExitLine", tYLabel);
	} else {
		com.inq.flash.client.chatskins.SkinControl.tYImageLabel = "";
	}
	var cid = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_ID);
	if(cid.length == 0) {
		/** @deprecated
		 * This part is deprecated because under the ticket RTDEV-10843
		 * the method HTTPConnectionHandler.prototype.putChatExitMsgComplete is deprecated,
		 * but this is a single place where "cid" comes as empty string.
		 */
		//com.inq.flash.client.chatskins.SkinControl.customerClosedChat();
	} else {
		/* Agent closed this chat, shut it down */
		this.getController().msgcntAtEntry = 0;
		this.getController().clientDisconnect = didClientDisconnect || !!forcedClose;
		if (this.getController().getChat().isAsyncChat() && (this.getController().getChat().isCiEnabledOnResolve() || !conversationResolved) && !forcedClose) {
			this.getController().shutdownQuietly(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_EXIT);
			com.inq.flash.client.chatskins.SkinControl.closeChatSession();
			com.inq.flash.client.control.PersistenceManager.ClearValues();
			com.inq.flash.client.control.PersistenceManager.reopen();
		} else {
			this.getController().shutdown(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_EXIT);
		}
		this.getController().disable();
		com.inq.flash.client.control.MinimizeManager.onClose();/* If agent exit's chat, then restore the chat window */
		com.inq.flash.client.chatskins.SkinControl.keyCount = 0;/*RTDEV-20027 - reset this count */
		if (this.getController().getChat().isAsyncChat() && (this.getController().getChat().isCiEnabledOnResolve() || !conversationResolved) && !forcedClose) {
			com.inq.flash.client.control.FlashPeer.reinitializeChatWithNewId();
		}
	}
};

/** @type {com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler;
